import { createContext } from "react";
import type { ModuleFeedback } from "../types";

interface ModuleFeedbackContextProps {
  config: ModuleFeedback.Config;
}

export const ModuleFeedbackContext =
  createContext<ModuleFeedbackContextProps | null>(null);
